import React, { useState, useEffect } from "react";
import "../../index.css";
import "../../App.css";
import {
  Row,
  Col,
  Input,
  Typography,
  Radio,
  Tag,
  Button,
  Checkbox,
  Spin,
} from "antd";
import type { RadioChangeEvent } from "antd";
import {
  // handleUpdatePainSymptomsDuration,
  handleUpdatePainSymptomsSelectedPainDescriptions,
  handleUpdatePainSymptomsFreq,
  handleUpdatePainSymptomsTrigger,
  handleUpdatePainSymptomsDailyImpact,
  handleTogglePainSymptomsShowTriggerTextBox,
  handleTogglePainSymptomsShowPainChangeTextBox,
  handleTogglePainSymptomsShowPainSevereTimeTextBox,
  handleUpdatePainSymptomsChangeInfo,
  handleUpdatePainSymptomsSpecificTimeInDayInfo,
  handleUpdatePainSymptomsTriggerInfo,
  handleGoToNextStep,
  handleUpdateErrorsOfOrderCreamForm,
  handleGoBack,
  saveStep3Api,
  getOrderByTransactionIdApi,
} from "../../redux-toolkit/slices/orderCreamSlice";
import { useSearchParams } from "react-router-dom";

import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import {
  validatePainFactors,
  validatePainSymptoms,
} from "../../schemas/OrderCream";
import ErrorList from "../Items/ErrorsList";

const painDescriptionOptions: string[] = [
  "Swelling",
  "Redness",
  "Warmth in the area",
  "Muscle spasms",
  "Weakness",
  "Tingling sensations",
  "None of these",
];

const OcAssociatedsymptoms = () => {
  const orderCreamForm = useSelector((state: RootState) => state.orderCream);
  const { painSymptoms, isError, errors, transactionId, currentStep, isLoading } = orderCreamForm;
  const {
    selectedPainDescriptions,
    painFreq,
    painTrigger,
    painDailyImpact,
    showTriggerTextBox,
    showPainChangeTextBox,
    showPainSevereTimeTextBox,
    painTriggerInfo,
    painChangeInfo,
    painSpecificTimeInDayInfo,
  } = painSymptoms;
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoadingOrder, setIsLoadingOrder] = useState(false);
  
  // Fetch order data when component mounts
  useEffect(() => {
    const fetchOrder = async () => {
      if (transactionId) {
        setIsLoadingOrder(true);
        try {
          const orderData = await dispatch(
            getOrderByTransactionIdApi(transactionId)
          ).unwrap();
          // The Redux reducer will automatically populate the state with order data
          // including painSymptoms if it exists
        } catch (error) {
          console.error("Error loading order:", error);
        } finally {
          setIsLoadingOrder(false);
        }
      }
    };
    
    fetchOrder();
  }, [transactionId, dispatch]);
  
  const handleBack = () => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1;
      const newParams = new URLSearchParams(searchParams);
      newParams.set("step", prevStep.toString());
      setSearchParams(newParams, { replace: true });
      // Don't call handleGoBack() - let the parent component sync from URL
    }
  };

  const handlePainDescriptionChange = (description: string) => {
    dispatch(handleUpdatePainSymptomsSelectedPainDescriptions(description));
  };

  const handlePainfreqChange = (e: RadioChangeEvent) => {
    dispatch(handleUpdatePainSymptomsFreq(e.target.value));
  };

  const handlePainTriggersChange = (e: RadioChangeEvent) => {
    dispatch(handleUpdatePainSymptomsTrigger(e.target.value));
  };

  const handlePainDailyimpactChange = (e: RadioChangeEvent) => {
    dispatch(handleUpdatePainSymptomsDailyImpact(e.target.value));
  };
  const handleSubmit = async () => {
    // Validate radio buttons first - check for valid values
    const validPainFreq = ["constant", "intermittent", "occasional"];
    const validPainTrigger = ["at_rest", "being_active", "both", "neither"];
    const validPainDailyImpact = ["none", "little_bit", "moderately", "quite_bit", "extremely"];

    if (!painFreq || 
        painFreq === "" || 
        painFreq === null || 
        painFreq === undefined ||
        (typeof painFreq === 'string' && painFreq.trim() === "") ||
        !validPainFreq.includes(painFreq)) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please choose your pain frequency."],
        })
      );
    }

    if (!painTrigger || 
        painTrigger === "" || 
        painTrigger === null || 
        painTrigger === undefined ||
        (typeof painTrigger === 'string' && painTrigger.trim() === "") ||
        !validPainTrigger.includes(painTrigger)) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please choose your pain trigger."],
        })
      );
    }

    if (!painDailyImpact || 
        painDailyImpact === "" || 
        painDailyImpact === null || 
        painDailyImpact === undefined ||
        (typeof painDailyImpact === 'string' && painDailyImpact.trim() === "") ||
        !validPainDailyImpact.includes(painDailyImpact)) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please tell us how pain impacts your daily activities."],
        })
      );
    }

    if (showTriggerTextBox === null || showTriggerTextBox === undefined) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please choose if there's any specific pain triggers."],
        })
      );
    }

    if (showPainChangeTextBox === null || showPainChangeTextBox === undefined) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please choose if your pain changes throughout the day."],
        })
      );
    }

    if (showPainSevereTimeTextBox === null || showPainSevereTimeTextBox === undefined) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please choose if you have severe pain over any specific time."],
        })
      );
    }

    // Remove _id before validation
    const { _id, ...painSymptomsWithoutId } = painSymptoms as any;
    const { isError, errors } = validatePainSymptoms(painSymptomsWithoutId);

    if (isError) {
      return dispatch(handleUpdateErrorsOfOrderCreamForm({ isError, errors }));
    }

    if (showTriggerTextBox && painTriggerInfo.trim() === "") {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please Complete Response"],
        })
      );
    }
    if (showPainChangeTextBox && painChangeInfo.trim() === "") {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please Complete Response"],
        })
      );
    }
    if (
      showPainSevereTimeTextBox &&
      painSpecificTimeInDayInfo.trim() === ""
    ) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Please Complete Response"],
        })
      );
    }

    if (!transactionId) {
      return dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Transaction ID is missing. Please refresh the page."],
        })
      );
    }

    try {
      // Sanitize painSymptoms to remove _id fields
      const sanitizedPainSymptoms = {
        selectedPainDescriptions: painSymptoms.selectedPainDescriptions || [],
        painFreq: painSymptoms.painFreq,
        painTrigger: painSymptoms.painTrigger,
        painDailyImpact: painSymptoms.painDailyImpact,
        showTriggerTextBox: painSymptoms.showTriggerTextBox ?? null,
        showPainChangeTextBox: painSymptoms.showPainChangeTextBox ?? null,
        showPainSevereTimeTextBox: painSymptoms.showPainSevereTimeTextBox ?? null,
        painTriggerInfo: painSymptoms.painTriggerInfo || '',
        painChangeInfo: painSymptoms.painChangeInfo || '',
        painSpecificTimeInDayInfo: painSymptoms.painSpecificTimeInDayInfo || '',
      };

      await dispatch(
        saveStep3Api({
          transactionId,
          painSymptoms: sanitizedPainSymptoms,
        })
      ).unwrap();

      // Update URL with new step
      const newParams = new URLSearchParams(searchParams);
      newParams.set("step", "4");
      setSearchParams(newParams, { replace: true });

      dispatch(handleGoToNextStep());
    } catch (error) {
      dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: ["Failed to save step. Please try again."],
        })
      );
    }
  };

  return (
    <div className="associated-symptoms-entry">
      <div className="flex flex-col gap-5 w-full">
        {/* Associated Symptoms Question */}
        <div className="flex flex-col gap-2">
          <label className="h6 text-theme-text-secondary">
            <strong>Do you experience any of the following with your pain? (Select all that apply) *</strong>
          </label>
          <div className="flex flex-col gap-2">
            {painDescriptionOptions.map((option) => (
              <label key={option} className="flex items-center gap-3 cursor-pointer">
                <input 
                  type="checkbox" 
                  className="twinge-checkbox"
                  checked={selectedPainDescriptions.includes(option)}
                  onChange={() => handlePainDescriptionChange(option)}
                />
                <span className="body1">{option}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Pain Frequency Question */}
        <div className="flex flex-col gap-2">
          <label className="h6 text-theme-text-secondary">
            <strong>Describe the frequency of your pain: Constant, Intermittent, Occasional. *</strong>
          </label>
          <Radio.Group onChange={handlePainfreqChange} value={painFreq}>
            <Radio value="constant">Constant</Radio>
            <Radio value="intermittent">Intermittent</Radio>
            <Radio value="occasional">Occasional</Radio>
          </Radio.Group>
        </div>

        {/* Pain Trigger Question */}
        <div className="flex flex-col gap-2">
          <label className="h6 text-theme-text-secondary">
            <strong>The pain worsens when I'm *</strong>
          </label>
          <Radio.Group
            onChange={handlePainTriggersChange}
            value={painTrigger}
          >
            <Radio value="at_rest">At rest</Radio>
            <Radio value="being_active">Being active</Radio>
            <Radio value="both">Both</Radio>
            <Radio value="neither">Pain or resting don't make it worse</Radio>
          </Radio.Group>
        </div>

        {/* Specific Triggers Question */}
        <div className="flex flex-col gap-2">
          <label className="h6 text-theme-text-secondary">
            <strong>Are there specific triggers that exacerbate the pain? *</strong>
          </label>
          <Radio.Group
            value={
              showTriggerTextBox !== null
                ? showTriggerTextBox === true
                  ? "yes"
                  : "no"
                : ""
            }
            onChange={(e) =>
              dispatch(
                handleTogglePainSymptomsShowTriggerTextBox(
                  e.target.value === "yes"
                )
              )
            }
          >
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
          {showTriggerTextBox && (
            <Input.TextArea
              rows={4}
              value={painTriggerInfo}
              onChange={(e) =>
                dispatch(handleUpdatePainSymptomsTriggerInfo(e.target.value))
              }
              placeholder="Please describe any triggers..."
              className="pain-trigger-text-area"
            />
          )}
        </div>

        {/* Pain Change Question */}
        <div className="flex flex-col gap-2">
          <label className="h6 text-theme-text-secondary">
            <strong>Does the pain change throughout the day? *</strong>
          </label>
          <Radio.Group
            value={
              showPainChangeTextBox !== null
                ? showPainChangeTextBox === true
                  ? "yes"
                  : "no"
                : ""
            }
            onChange={(e) =>
              dispatch(
                handleTogglePainSymptomsShowPainChangeTextBox(
                  e.target.value === "yes"
                )
              )
            }
          >
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
          {showPainChangeTextBox && (
            <Input.TextArea
              rows={4}
              value={painChangeInfo}
              onChange={(e) =>
                dispatch(handleUpdatePainSymptomsChangeInfo(e.target.value))
              }
              placeholder="Describe how your pain varies during the day..."
              className="pain-change-text-area"
            />
          )}
        </div>

        {/* Severe Pain Times Question */}
        <div className="flex flex-col gap-2">
          <label className="h6 text-theme-text-secondary">
            <strong>Are there specific times when the pain is most severe? *</strong>
          </label>
          <Radio.Group
            value={
              showPainSevereTimeTextBox !== null
                ? showPainSevereTimeTextBox === true
                  ? "yes"
                  : "no"
                : ""
            }
            onChange={(e) =>
              dispatch(
                handleTogglePainSymptomsShowPainSevereTimeTextBox(
                  e.target.value === "yes"
                )
              )
            }
          >
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
          {showPainSevereTimeTextBox && (
            <Input.TextArea
              rows={4}
              value={painSpecificTimeInDayInfo}
              onChange={(e) =>
                dispatch(
                  handleUpdatePainSymptomsSpecificTimeInDayInfo(e.target.value)
                )
              }
              placeholder="Specify when your pain is most severe..."
              className="pain-severe-time-text-area"
            />
          )}
        </div>

        {/* Daily Impact Question */}
        <div className="flex flex-col gap-2">
          <label className="h6 text-theme-text-secondary">
            <strong>How much does this pain interfere with your daily activities? *</strong>
          </label>
          <Radio.Group
            onChange={handlePainDailyimpactChange}
            value={painDailyImpact}
          >
            <Radio value="none">Not at all</Radio>
            <Radio value="little_bit">A little bit</Radio>
            <Radio value="moderately">Moderately</Radio>
            <Radio value="quite_bit">Quite a bit</Radio>
            <Radio value="extremely">Extremely</Radio>
          </Radio.Group>
        </div>
        {/* Error Display */}
        {isError === true && (
          <div className="mt-6">
            <ErrorList errors={errors} />
          </div>
        )}

        {/* Submit Button */}
        <div className="flex justify-center gap-4" style={{ marginTop: "40px" }}>
          <button
            onClick={handleBack}
            className="caption2 transition-colors duration-200"
            style={{ color: 'var(--primary-500)', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer' }}
          >
            Previous
          </button>
          <button
            onClick={handleSubmit}
            className="btn btn-primary btn-lg"
            disabled={isLoading}
            style={{ position: 'relative', minWidth: '120px' }}
          >
            {isLoading ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <Spin size="small" />
                Saving...
              </span>
            ) : (
              'Next'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OcAssociatedsymptoms;
